import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import SearchResultsPage2 from "./SearchResultsPage2";
import HomePage from "./HomePage";
import QuestionPage from "./QuestionPage";
import AISearchResultsPage from "./AISearchResultsPage";
import AIHomePage from "./AIHomePage";
import { useTracking } from "react-tracking";

const timeLimits = { 1: { overall: 300, reading: 210 } };

function QuizContainerPage() {
    const [step, setStep] = useState(0);
    const questions = require("../contents/questions.json");
    const quiz = questions[0];
    const [query, setQuery] = useState("");
    const [done, setDone] = useState(false);
    const { set, variant, question } = useParams();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { track, trackEvent } = useTracking({ page: "QuizContainerPage" });
    const [timeLeft, setTimeLeft] = useState(timeLimits[parseInt(question)].reading); // 90 seconds countdown

    // const handleAnswerClick = (index) => {
    //     if (selectedAnswers.includes(index)) {
    //         setSelectedAnswers(selectedAnswers.filter((answer) => answer !== index));
    //     } else {
    //         setSelectedAnswers([...selectedAnswers, index]);
    //     }
    // };

    // const handleSubmit = () => {
    //     props.onSubmit(quiz.answers.length > 0 ? selectedAnswers : selectedAnswers[0]);
    //     alert("Result submitted successfully. Please proceed to the next section of the study");
    // };

    useEffect(() => {
        if (timeLeft > 0) {
            const timerId = setInterval(() => {
                setTimeLeft(timeLeft - 1);
            }, 1000);
            return () => clearInterval(timerId);
        } else {
            // Handle timeout (e.g., navigate to a timeout page or show a message)
            if (step == 2) {
                alert("Time's up for this question! You will be automatically moved to the next question.");
                setDone(true);
            } else {
                alert("Time's up for reading! You will be automatically moved to the question.");
                setStep(step + 1);
                setTimeLeft(timeLimits[parseInt(question)].overall - timeLimits[parseInt(question)].reading);
            }
        }
    }, [timeLeft]);

    const handleNextPage = () => {
        if (step == 1) {
            // Going from search results to question
            setTimeLeft(timeLeft + timeLimits[parseInt(question)].overall - timeLimits[parseInt(question)].reading);
        }
        setStep(step + 1);
    };

    useEffect(() => {
        console.log("useEffect done", done);
        const handleBeforeUnload = (event) => {
            const message = "You have not finished the quiz. Are you sure you want to leave?";
            event.returnValue = message; // For most browsers
            return message; // For some older versions
        };

        if (!done) {
            window.addEventListener("beforeunload", handleBeforeUnload);
        } else {
            window.removeEventListener("beforeunload", handleBeforeUnload);

            //if (parseInt(question) == 2) {
            window.dataLayer.push({ PROLIFIC_PID: searchParams.get("pid") });
            window.dataLayer.push({ URL: window.location.href });
            const dataLayerString = JSON.stringify(window.dataLayer);
            const formUrl = "https://docs.google.com/forms/d/e/1FAIpQLSewBgCP5vhHW1Q_IuQCTBf1a0HzzO9mE3QUsUiBcKY3KdhEnQ/formResponse";
            const formData = new FormData();
            formData.append("entry.1216458476", dataLayerString);

            fetch(formUrl, {
                method: "POST",
                mode: "no-cors",
                body: formData,
            })
                .then(() => {
                    alert("Result submitted successfully. Please proceed to the next section of the study");
                    //window.location.href = "https://www.example.com";
                })
                .catch((error) => {
                    console.error("Error submitting DataLayer:", error);
                });
            //} else {
            //setTimeLeft(timeLimits[parseInt(question) + 1].reading);
            //setDone(false);
            //setStep(0);
            //navigate(`/${set}/${variant}/${parseInt(question) + 1}`, { replace: true });
            //}
        }

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [done, question, set, variant, navigate]);

    useEffect(() => {
        trackEvent({ action: "Page_view", question: question, step: step, timestamp: new Date().toISOString() });
    }, [question, step, trackEvent]);

    return (
        <div className="relative my-8 h-screen w-full flex flex-col justify-center bg-gray-50 z-20">
            <header className="fixed top-0 flex justify-between  w-full bg-white/90 shadow-lg z-30">
                
                <div className="flex space-x-4 mt-8 p-3">
                    <div className="text-black text-sm">
                        {step != 2 ? "Search" : "Answer"} time left: {timeLeft}s
                    </div>
                    {step === 1 ? (
                        <button
                            onClick={handleNextPage}
                            className="bg-blue-500 text-white text-base px-4 mx-4 py-2 rounded-full border-0 hover:bg-blue-700 transition duration-300"
                        >
                            To Question
                        </button>
                    ) : null}
                </div>
            </header>
            <div className="w-full">
                {step === 0 ? (
                    set === "1" ? (
                        <HomePage
                            handleSearch={(query) => {
                                setStep(step + 1);
                                setQuery(query);
                            }}
                            question={question}
                        />
                    ) : (
                        <AIHomePage
                            handleSearch={(query) => {
                                setStep(step + 1);
                                setQuery(query);
                            }}
                            question={question}
                        />
                    )
                ) : step === 1 ? (
                    set === "1" ? (
                        <SearchResultsPage2 source={variant} searchQuery={query} question={question} />
                    ) : (
                        <AISearchResultsPage source={variant} searchQuery={query} question={question} />
                    )
                ) : (
                    <QuestionPage
                        question={question}
                        onSubmit={(answer) => {
                            trackEvent({
                                action: "Submit_q",
                                set: set,
                                variant: variant,
                                question: question,
                                answer: answer,
                                timestamp: new Date().toISOString(),
                            });
                            setDone(true);
                        }}
                    />
                )}
            </div>
        </div>
    );
}

export default QuizContainerPage;
